import styled from 'styled-components';
import { Box, IBoxProps, Flex, Text, mediaQueries } from '@lce/slice';

interface props extends IBoxProps {
  imageFirst?: boolean;
}

export const ProductBanner = styled(Box)`
  background-color: ${({ theme }) => theme.colors.orange};
`;

export const FlexContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;

  ${mediaQueries[1]} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const ImageWrapper = styled(Box)<props>`
  flex: 2 0 auto;
  align-self: flex-start;
  justify-self: flex-end;
  margin: 0 auto;

  ${mediaQueries[1]} {
    order: ${({ imageFirst }) => (imageFirst ? 'initial' : '1')};
    margin-bottom: 0;
  }
`;

export const Legal = styled(Text)`
  padding: 0 0 8px 0;
  font-size: 0.75rem;
  line-height: 1.08;

  ${mediaQueries[1]} {
    padding-bottom: 16px;
    max-width: 750px;
  }
`;

export const ButtonContainer = styled(Flex)`
  width: 100%;
  justify-content: center;

  ${mediaQueries[1]} {
    width: '362px';
  }
`;
